<template>
  <div style="min-width: 1300px;">
  	<div class="container-padding">
  		<!--头组件-->
  		<indexheader></indexheader>
  	</div>
  	
  	<div class="split"></div>
  		
  	<slot name="body"></slot>
    <div class="split"></div>
    
    <indexfooter></indexfooter>
    
    <contact version="jdb"></contact>
    
   
  </div>
</template>

<script>
//引入头组件
import indexheader from '@/view/layout/header/index.vue'

import indexfooter from '@/view/layout/footer/index.vue'
import contact from '@/view/layout/contact/index.vue'
	
export default {
  name: 'layout',
	components: {
		indexheader:indexheader,
		indexfooter:indexfooter,
		contact:contact
	},mounted:function(){
			// var storage=window.localStorage;
			//  var intro = introJs();
			//   intro.setOptions({
			//   	 prevLabel: "上一步",
		 //        nextLabel: "下一步",
		 //        skipLabel: "跳过",
		 //        doneLabel: "完成",
		 //        exitOnOverlayClick: false,
	  //           steps: [
	  //             {
	  //               element: document.getElementById("header-title-gide"),//在/view/layout/header/index.vue中
	  //               intro: "在这里选择您要进入的专利服务平台的版本",
	  //               position: 'bottom'
	  //             },
	  //             {
	  //               element: document.getElementById("report-data-gide"),//在/view/index/dataCenter/index.vue中
	  //               intro: "这里我们提供了一些免费的报告",
	  //               position: 'right'
	  //             },
	  //             {
	  //               element: document.getElementById("contact-gide"),//在/view/layout/contact/index.vue中
	  //               intro: "如有问题可在此处联系我们的客服",
	  //               position: 'left'
	  //             }
	  //           ]
   //        });
			// 		intro.onexit(function(){
			// 			if(storage){
			// 				storage.gide = 'complete';
			// 			}
			// 		});
			// 		if(storage && storage.gide == 'complete'){
			// 			return;
			// 		}
   //        intro.start();
		}
}
</script>

<style scoped>
	.container-padding{
		padding: 0 8%;
	}
	.split{
		background: linear-gradient(#4D81E7, #68B3EC);
		height: 6px;
	}
	
	
	
</style>



// WEBPACK FOOTER //
// src/view/layout/index.vue